var React = require('react');

function IcSendMessage (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"m1.51 3-.01 7 15 2-15 2 .01 7 20.99-9L1.51 3z","clipRule":"evenodd"}));
}

IcSendMessage.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = IcSendMessage;

IcSendMessage.default = IcSendMessage;
